import { Status } from '@Components/Base';

import { useAppSelector } from '@Hooks/index';

import { useGetTenderQuery } from '@Features/MaterialRequest/requests/TenderRequest/store/api/TenderRequestApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { useMemo } from 'react';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import styles from '../view-tab.module.css';
import tenderFieldSource from '../../FieldSource';

const DetailsTab: React.FC = () => {
  const tenderId = useAppSelector(getModalRecordKey);
  const { data } = useGetTenderQuery(tenderId!, {
    skip: !tenderId,
    refetchOnMountOrArgChange: true,
  });

  const fieldSource = useMemo(
    () =>
      data
        ? [
            ...tenderFieldSource({
              data,
            }),
          ]
        : [],
    [data]
  );

  if (!data) return null;

  return (
    <>
      {fieldSource.map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          {item.label === 'Status' ? (
            <Status
              className={styles.viewItemValue}
              text={String(item.value) || ''}
            />
          ) : (
            <span className={styles.viewItemValue}>
              {item.value || EMPTY_FIELD_PLACEHOLDER}
            </span>
          )}
        </div>
      ))}
    </>
  );
};

export default DetailsTab;
